import usePublicLogin from './usePublicLogin';

export default usePublicLogin;
